
<template>
  <el-dialog width="520px"
             v-dialog-drag
             title="关联展厅"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="associationExhibitionVisible">
    <el-form size="small"
             ref="associationExhibitionForm"
             label-position="top"
             label-width="185px"
             :model="associationExhibitionForm"
             :rules="associationExhibitionFormRules" v-loading="loading">
      <el-form-item label="选择关联展厅" prop="id">
        <el-select key="userid"   filterable placeholder="请选择" ref="mySelect3"  remote reserve-keyword  v-model="associationExhibitionForm.id">
          <el-option v-if="item.pid != 0"  v-for="(item,index) in exhibitionList" :key="item.id"   :label="item.exhibition_hall_name"   :value="item.id" :disabled="disabledIds.indexOf(item.id) > -1"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { exhibitionHallList } from "@/api";
import {mapState} from "vuex";
export default {
  name: "association_exhibition",
  props: {
    associationExhibitionVisible: {
      type: Boolean,
      default: false,
    },
    hallId: {
      type: Number,
      default: 0,
    },
    disabledIds: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      loading: false,
      btnDisabled: false,
      associationExhibitionForm: {
        id: '',
      },
      associationExhibitionFormRules: {
        id: [{required: true, message: '请选择关联的展厅', trigger: 'change'},],

      },
      exhibitionList:[]
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    if(this.hallId != 0){
      this.associationExhibitionForm.id = this.hallId
    }
    this.getExhibitionHallList()
  },
  mounted() {
  },
  methods: {
    // 获取展厅
    getExhibitionHallList(){
      this.loading = true
      let postData = {
        company_id:(this.userInfo && this.userInfo.company_id)  ? this.userInfo.company_id :'',
      }
      exhibitionHallList(postData).then(res => {
        if (res.code === 200) {
          this.exhibitionList = res.data
          if(this.hallId !=0 && this.exhibitionList.findIndex(find => find.id == this.hallId) < 0){
            this.associationExhibitionForm.id = ''
          }
        }
        this.loading = false
      })
    },
    handleClickCancel() {
      this.$refs.associationExhibitionForm.resetFields()
      this.$emit('update:associationExhibitionVisible', false)
    },

    handleClickConfirm() {
      this.$refs.associationExhibitionForm.validate(valid => {
        if (valid) {
          this.btnDisabled = true
          this.$message.success('关联成功')
          this.$emit('success',this.associationExhibitionForm)
          this.$emit('update:associationExhibitionVisible', false)
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.el-date-editor.el-input {
  width: 100%;
}
</style>
